import React, { useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, notification, Space, Dropdown } from "antd";
import {
  FileExcelOutlined,
  FileTextOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import normalizarCoordenada from "../../../utils/normalizarGeoreferencias";

const ExportVisitasTecnicas = ({ dataCompleta }) => {
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingJson, setLoadingJson] = useState(false);
  const [optionsVisible, setOptionsVisible] = useState(false);

  const exportToExcel = async () => {
    try {
      if (dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }
      setLoadingExcel(true);
      const workbook = new ExcelJS.Workbook();
      const templateResponse = await fetch(
        "/assets/plantilla_visitas_tecnicas.xlsx"
      );
      const templateBuffer = await templateResponse.arrayBuffer();
      await workbook.xlsx.load(templateBuffer);
      const worksheet = workbook.getWorksheet(1);
      let currentRow = 3;
      dataCompleta.forEach((item) => {
        const startRow = currentRow; // Fila de inicio para esta entrada
        let maxRow = currentRow; // Variable para rastrear la fila más baja ocupada
        worksheet.getCell(`A${startRow}`).value = item.codigoSIRR || "";
        worksheet.getCell(`B${startRow}`).value = item.fecha_registro || "";
        worksheet.getCell(`C${startRow}`).value = item.numero_visita || "";
        worksheet.getCell(`D${startRow}`).value = item.departamento || "";
        worksheet.getCell(`E${startRow}`).value = item.municipio || "";

        const lista_capacitaciones = item.lista_capacitaciones || [];
        if (lista_capacitaciones.length > 0) {
          currentRow = startRow; // Fila de inicio para esta entrada
          lista_capacitaciones.forEach((capacitacion) => {
            if (capacitacion && typeof capacitacion === "object") {
              worksheet.getCell(`F${currentRow}`).value =
                capacitacion.tema || "";
              worksheet.getCell(`G${currentRow}`).value =
                capacitacion.area || "";
              worksheet.getCell(`H${currentRow}`).value =
                capacitacion.tematica || "";
              worksheet.getCell(`I${currentRow}`).value =
                capacitacion.factor || "";
            }
            currentRow++; // Avanzar fila
          });
          maxRow = Math.max(maxRow, currentRow);
        }

        worksheet.getCell(`J${startRow}`).value = item.vereda || "";
        worksheet.getCell(`K${startRow}`).value = item.grupoTerritorial || "";
        worksheet.getCell(`L${startRow}`).value = item.codigoPREPP || "";
        worksheet.getCell(`M${startRow}`).value = item.nombreProyecto || "";
        worksheet.getCell(`N${startRow}`).value = item.quienRecibeVisita || "";
        worksheet.getCell(`O${startRow}`).value = item.nombreParticipante || "";
        worksheet.getCell(`P${startRow}`).value =
          item.numeroIdentificacion || "";

        worksheet.getCell(`Q${startRow}`).value =
          item.sexo_sir || "";
        worksheet.getCell(`R${startRow}`).value =
          item.numeroPersonasParticipan || "";
        worksheet.getCell(`S${startRow}`).value = item.numeroHombres
          ? Math.floor(parseInt(item.numeroHombres, 10))
          : 0;
        worksheet.getCell(`T${startRow}`).value = item.numeroMujeres
          ? Math.floor(parseInt(item.numeroMujeres, 10))
          : 0;
        worksheet.getCell(`U${startRow}`).value = item.horaInicio || "";
        worksheet.getCell(`V${startRow}`).value = item.horaFin || "";

        //PUNTO DE GEOREFERENCIA
        worksheet.getCell(`W${startRow}`).value =
          normalizarCoordenada(item.latuser) ?? "";
        worksheet.getCell(`X${startRow}`).value =
          normalizarCoordenada(item.lnguser) ?? "";

        worksheet.getCell(`Y${startRow}`).value = item.linea_productiva || "";

        //ASPECTOS METODOLÓGICOS
        worksheet.getCell(`Z${startRow}`).value =
          item.modalidad_sesion_capacitacion || "";

        //ACTIVIDADES DESARROLLADAS EN LA VISITA
        worksheet.getCell(`AA${startRow}`).value =
          item.actividadesDesarrolladas || "";

        //AVANCE DE ACTIVIDADES POR FACTORES DE SOSTENIBILIDAD
        worksheet.getCell(`AB${startRow}`).value = item.avanceFactor1 || "";
        worksheet.getCell(`AC${startRow}`).value = item.avanceFactor2 || "";
        worksheet.getCell(`AD${startRow}`).value = item.avanceFactor3 || "";
        worksheet.getCell(`AE${startRow}`).value = item.avanceFactor4 || "";
        worksheet.getCell(`AF${startRow}`).value = item.avanceFactor5 || "";
        worksheet.getCell(`AG${startRow}`).value = item.avanceFactor6 || "";
        worksheet.getCell(`AH${startRow}`).value = item.avanceFactor7 || "";
        worksheet.getCell(`AI${startRow}`).value = item.avanceFactor8 || "";

        worksheet.getCell(`AJ${startRow}`).value = item.proximaSesion || "";
        worksheet.getCell(`AK${startRow}`).value = item.modalidad || "";
        worksheet.getCell(`AL${startRow}`).value = item.hallazgos || "";
        worksheet.getCell(`AM${startRow}`).value = item.recomendaciones || "";

        //ACUERDOS

        const lista_acuerdos = item.acuerdos || [];
        if (lista_acuerdos.length > 0) {
          currentRow = startRow; // Fila de inicio para esta entrada
          lista_acuerdos.forEach((acuerdo) => {
            if (acuerdo && typeof acuerdo === "object") {
              worksheet.getCell(`AN${currentRow}`).value =
                acuerdo.compromiso || "";
              worksheet.getCell(`AO${currentRow}`).value =
                acuerdo.responsable || "";
              worksheet.getCell(`AP${currentRow}`).value =
                acuerdo.fechaLimite || "";
            }
            currentRow++; // Avanzar fila solo si hay comercialización
          });
          maxRow = Math.max(maxRow, currentRow);
        }

        worksheet.getCell(`AQ${startRow}`).value = item.fuente || "";
        worksheet.getCell(`AR${startRow}`).value = item.name_responsable || "";
        worksheet.getCell(`AS${startRow}`).value = item.email_responsable || "";

        for (let row = startRow; row <= maxRow; row++) {
          worksheet.getCell(`A${row}`).value = item.codigoSIRR || "";
          worksheet.getCell(`B${row}`).value = item.fecha_registro || "";
          worksheet.getCell(`C${row}`).value = item.numero_visita || "";
          worksheet.getCell(`D${row}`).value = item.departamento || "";
          worksheet.getCell(`E${row}`).value = item.municipio || "";
        }

        currentRow = maxRow;
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, "Informe_VisitasTecnicas_PAATI.xlsx");
      notification.success({
        message: "Éxito",
        description: "Excel exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar Excel:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el Excel.",
        duration: 3,
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const exportToJSON = async () => {
    try {
      if (!dataCompleta || dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }
      setLoadingJson(true);
      const jsonBlob = new Blob([JSON.stringify(dataCompleta, null, 2)], {
        type: "application/json",
      });
      saveAs(jsonBlob, "Informe_VisitasTecnicas_PAATI.json");
      notification.success({
        message: "Éxito",
        description: "JSON exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar JSON:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el JSON.",
        duration: 3,
      });
    } finally {
      setLoadingJson(false);
    }
  };

  const menuItems = [
    {
      key: "excel",
      label: (
        <Button
          type="text"
          icon={<FileExcelOutlined />}
          onClick={exportToExcel}
          loading={loadingExcel}
          disabled={loadingExcel}
        >
          Exportar a Excel
        </Button>
      ),
    },
    {
      key: "json",
      label: (
        <Button
          type="text"
          icon={<FileTextOutlined />}
          onClick={exportToJSON}
          loading={loadingJson}
          disabled={loadingJson}
        >
          Exportar a JSON
        </Button>
      ),
    },
  ];

  return (
    <Space>
      <Dropdown
        menu={{ items: menuItems }}
        placement="bottomLeft"
        trigger={["click"]}
      >
        <Button type="primary" icon={<DownloadOutlined />}>
          Exportar
        </Button>
      </Dropdown>
    </Space>
  );
};

export default ExportVisitasTecnicas;
